import { IconButton } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
    overflow: visible;
    box-shadow: var(--box-shadow);
    padding: 1rem;
    border-radius: var(--border-radius);
    background: #ffffff;
    min-width: 15.5rem;
    max-width: 15.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    > * {
        margin-bottom: 0.5rem;
    }

    > header {
        width: 100%;
        height: 2rem;
        margin-top: -1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: visible;
    }

    > main {
        overflow: visible;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        > span {
            font-size: 12px;
            min-height: 1.2rem;
            max-height: 1.2rem;
            width: 100%;
            text-align: center;
            color: var(--color-secondary);
            font-weight: 500;
        }

        > h2 {
            font-size: 1.2rem;
            font-weight: bold;
            width: 100%;
            text-align: center;
        }
    }

    > footer {
        width: 100%;
    }

    ${(props) => props.pointer && `cursor:pointer;`}
`;

export const InfoContainer = styled(IconButton)``;
